<section>
    <div class="block" *ngIf="id==1">
        <h1>How does it work?</h1>
        <h2>Step 1</h2>
        <p>Choose a dress we have a number of categories to choose from, find the dress you are looking for</p>
        <h2>Step 2</h2>
        <p>Click on add to cart or view detail. Once you are satisfied choose the number of days you want dress for and cick add to cart</p>
        <h2>Step 3</h2>
        <p>When you have the desired dress in the cart proceed to checkout and fill the necessary field. Review your order and get it delivered
            to your doorstep.
        </p>
    </div>

    <div class="block" *ngIf="id==2">
        <h1>Returns and Refunds</h1>
        <p>Each and every dress on Zebaish is unique because they might be from different vendor, and hence each dress have a different
            policy when it comes to return and refund policy. When you order a dress and want to know the dresses return and refund policy you 
            can click on the view detail button on dress and see the r&r policy in description section.
        </p>
        <p>But there are some rules that apply to all of them:</p>
        <ul>
            <li>Return and refund is only possible if the dress or its size is wrong</li>
            <li>The dress must not be damaged or worn more than once(that too for trial purpose)</li>
            <li>Must contact the Team Zebaish the moment you realize something is wrong and you might need a return or refund</li>
        </ul>
    </div>

    <div class="block" *ngIf="id==3">
        <h1>What is Security Deposit</h1>
        <p>Security deposit is as the name suggest for security of dress, it is a assurance for the vendor that his dress is in safe hands
            and once he recieves back his dress in good condition (not damaged or torn) this security deposit will be returned to you.
            This security deposit will not be refunded in case you have damaged the dress, in that case you will have to give the estimated amount
            for the repair of that dress. And what if the dress is irreperiable, in that case you will have to give the complete amount of the dress to
            the vendor and the damaged dress will be handed to you.
        </p>
    </div>

    <div class="block">
        <p>Still have a question? Contact us at 021-34171009 or email us at info@zebaish.com</p>
    </div>
</section>